import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var Size = /*#__PURE__*/function () {
  function Size(pixelValue) {
    _classCallCheck(this, Size);
    this.pixelValue = pixelValue;
  }
  _createClass(Size, [{
    key: "value",
    value: function value() {
      return this.pixelValue;
    }
  }, {
    key: "addPixels",
    value: function addPixels(pixels) {
      return new Size(this.pixelValue + pixels);
    }
  }, {
    key: "multiply",
    value: function multiply(factor) {
      return new Size(this.pixelValue * factor);
    }
  }]);
  return Size;
}();
export { Size as default };
//# sourceMappingURL=Size.js.map